<template>
  <div class="completa-preventivo">
    <div id="completaPreventivo" class="cursor-pointer bg-primary text-center py-4 d-flex justify-content-center"
      @click="onCompleta">
      <div class="d-flex justify-content-center">
        <h6 class="adj-icon before-icon-completa-preventivo text-uppercase text-white m-0 mr-2">
          completa il preventivo
        </h6>
        <img src="../../../assets/images/svg/white/icone_arrow-3.svg" width="14px" />
      </div>
    </div>
    <ModalSpesePratica ref="modalSpesePratica" @confirm="onConfermaSpese" />
    <ModalCompletaPratica ref="modalCompletaPratica" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SpesePanel from "./SpesePanel";
import ModalCompletaPratica from "./modals/ModalCompletaPratica";
import CompletaPraticaAction from "../../actions/CompletaPraticaAction";
import CaricaPraticaAction from "../../actions/CaricaPraticaAction";
import ModalSpesePratica from "./modals/ModalSpesePratica";
import AnalyticEvents from "../../common/AnalyticEvents";
import ContentUtils from "../../utils/ContentUtils";
import {
  PRODUCT_VOLO_HOTEL,
  PRODUCT_TOUR,
  PRODUCT_EXPERIENCE,
} from "../../../types/products";

export default {
  name: "CompletaPreventivo",
  mixins: [
    CaricaPraticaAction,
    CompletaPraticaAction,
    AnalyticEvents,
    ContentUtils,
  ],
  components: { ModalSpesePratica, ModalCompletaPratica, SpesePanel },
  data() {
    return {
      gtagdData: {},
    };
  },
  computed: {
    list() {
      return this.getSpeseAccessorie();
    },
  },
  methods: {
    ...mapGetters([
      "getSpeseAccessorie",
      "getSelectedHotels",
      "getTrasferimentiSelected",
      "getSelectedTour",
      "getServiziSelected",
      "getExperienceSelected",
      "getTransferListString",
      "getServicesListString",
      "isExperience",
      "isVoloHotel",
      "isTour",
    ]),

    updateData(data) {
      this.gtagData = data;
    },
    isVoloHotel() {
      return this.getSearch().product === PRODUCT_VOLO_HOTEL;
    },
    isTour() {
      return this.getSearch().product === PRODUCT_TOUR;
    },
    isExperience() {
      return this.getSearch().product === PRODUCT_EXPERIENCE;
    },
    getServicesListString() {
      let services = [];
      for (let a in this.getServiziSelected()) {
        services.push(this.getServiziSelected()[a].detail.name);
      }
      return services.length > 0
        ? services.join(" || ")
        : "nessun servizio aggiunto";
    },
    getTransferListString() {
      let transfer = [];
      for (let a in this.getTrasferimentiSelected()) {
        transfer.push(
          this.getTrasferimentiSelected()[a].detail.name +
          (this.getTrasferimentiSelected()[a].isAndata
            ? " - andata"
            : " - ritorno")
        );
      }
      return transfer.length > 0
        ? transfer.join(" || ")
        : "nessun trasferimento aggiunto";
    },
    onCompleta() {
      const selectionType = this.isTour()
        ? "group_tour"
        : this.isVoloHotel()
          ? "free_trip"
          : "experience";

      const gtagData = new Object();
      gtagData.travel_solution = selectionType;
      gtagData.airport_location = this.getSearch().hasOwnProperty('aereoporto') ? this.getSearch().aereoporto.label : "null";
      if (selectionType == "free_trip" || selectionType == "experience") {
        gtagData.hotel = this.getSelectedHotels()[0].hotel.config.nome;
        gtagData.activity = this.getServicesListString();
        gtagData.transfers = this.getTransferListString();
      }
      if (selectionType == "group_tour") {
        gtagData.tour_name = this.getSelectedTour().anagrafica.element.name;
      }
      if (selectionType == "experience") {
        gtagData.experience_name = this.getExperienceSelected().titolo;
      }

      this.updateData(gtagData);

      this.trackTabCompletaPreventivo();
      this.caricaPratica().then(() => {
        this.$refs.modalSpesePratica.openWithTag(this.gtagData);
      });
    },
    onConfermaSpese() {
      this.completaPratica().then(() => {
        this.$refs.modalCompletaPratica.open();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CompletaPreventivo.vue